import * as Sentry from '@sentry/react';
import { memo, useEffect } from 'react';

import { AuthService } from 'shared/config/oidcClient/authServices';

export const LoginRedirectPage = memo(() => {
  useEffect(() => {
    const authService = new AuthService();
    authService.login().catch((error: unknown) => {
      Sentry.captureException(error);
    });
  }, []);

  return <></>;
});
